export default __webpack_public_path__ + "static/media/eventTicketMobile.dab66ec1.png";